<template>
  <m-btn
    :button-style="buttonStyle"
    :color="selected ? 'primary' : ''"
    :outlined="selected"
    :clickable="clickable"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <div
      class="_select-button-content"
    >
      <slot name="icon">
        <m-icon
          v-if="icon"
          class="_icon"
          :type="icon"
          :color="iconColor"
          :size="iconSize"
        />
      </slot>
      <div
        class="_title"
        :class="{ '-selected': selected }"
      >
        <slot />
      </div>
    </div>
  </m-btn>
</template>

<script>
export default {
  name: 'SelectBtn',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '16',
    },
  },
  emits: ['click'],
  computed: {
    buttonStyle() {
      const style = {};
      if (this.selected) {
        style['border-width'] = '.2rem';
      }
      return style;
    },
  },
};
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
._select-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ._icon {
    margin-top: .4rem;
    margin-bottom: .6rem;
  }

  ._title {
    font-size: $font-size-1;
    font-weight: $font-weight-medium;
    color: $font-color-secondary;

    &.-selected {
      color: inherit;
    }
  }
}
</style>
